<script setup>
import { computed } from "vue";
import { useTextStore } from "@/stores/useTextStore";
import DeleteConfirmModal from "@/components/Generics/DeleteConfirmModal.vue";

const props = defineProps({
  text: {
    type: Object,
    required: true,
  },
});

const emit = defineEmits(["close", "text-deleted", "notify"]);
const store = useTextStore();

// ✅ título do texto vindo da store (fallback props)
const textTitle = computed(() => {
  return (
    store.selectedText?.title ||
    store.selectedText?.Title ||
    props.text?.title ||
    props.text?.Title ||
    ""
  );
});

// ✅ mensagem da pergunta de confirmação
const messageTitle = computed(() => {
  const title = textTitle.value?.trim();
  if (!title) return "Tem certeza que deseja apagar este texto?";
  return `Tem certeza que deseja apagar o texto "${title}"?`;
});

function buildDeleteTextError(error) {
  return (
    error?.response?.data?.message ||
    error?.message ||
    "Ocorreu um erro ao excluir o texto."
  );
}

async function onConfirmDelete() {
  try {
    await store.deleteTextById(props.text.textId);

    // 🔥 toast **SEM NOME** (conforme solicitado)
    emit("notify", {
      type: "success",
      message: "Texto apagado com sucesso.",
    });

    emit("text-deleted");
    emit("close");
  } catch (error) {
    const msg = buildDeleteTextError(error);

    emit("notify", {
      type: "error",
      message: msg,
    });

    throw new Error(msg);
  }
}
</script>

<template>
  <DeleteConfirmModal
    :show="true"
    title="Apagar Texto"
    :messageTitle="messageTitle"
    messageSubtitle="Ao apagá-lo serão excluídas também todas as Atividades e Notas vinculadas a ele. Esta ação não pode ser desfeita."
    confirmText="Sim, apagar"
    cancelText="Cancelar"
    loadingText="Apagando..."
    :onConfirm="onConfirmDelete"
    @close="emit('close')"
  />
</template>
